import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import english from "./locales/en-gb";
import italian from "./locales/italian";
import french from "./locales/french";
import spanish from "./locales/spanish";
import dayjs from "dayjs";

// Import matching dayjs locales
import "dayjs/locale/en-gb";
import "dayjs/locale/it";
import "dayjs/locale/fr";
import "dayjs/locale/es";

// the translations
const resources = {
    enGb: { translation: english },
    it: { translation: italian },
    fr: { translation: french },
    es: { translation: spanish }
};

// Get the language of the system
const systemLang = navigator.language;

// Get the language from the browser if it has been set
const defaultLang = localStorage.getItem("cvControllerLang")
    ? localStorage.getItem("cvControllerLang")
    : systemLang;

i18n.use(initReactI18next) // passes i18n down to react-i18next
    .init({
        resources,
        fallbackLng: "enGb",
        lng: resources[defaultLang] ? defaultLang : "enGb",
        interpolation: {
            escapeValue: false
        }
    });

dayjs.locale(i18n.language || "enGb");

export const strings = (key, options) => i18n.t(key, options);
export default i18n;
